import { appState } from '../core/state';
import { can } from '../core/access';
import { esc, showModalErr } from '../ui/modal';
import { t } from '../ui/lang';
import { inlineStreams } from '../stream/inline-stream';
import { powerIconSvg } from '../stream/stream-controls-shared';
import { showAppsModal, showShellModal } from './device-modals';
let deviceCommandsPopover = null;
let deviceCommandsPopoverEvents = null;
export function closeDeviceCommandsPopover() {
    deviceCommandsPopoverEvents?.abort();
    deviceCommandsPopoverEvents = null;
    deviceCommandsPopover?.remove();
    deviceCommandsPopover = null;
}
// `noVideo` — the device's farm can't stream (aggregator / adb-only): Screen off/on
// ride the live scrcpy control channel, which such a device never has, so they're
// dropped. Its screen is driven from the card's ADB controls instead (nav + screenshot).
export function showDeviceCommandsPopover(anchor, udid, displayName, noVideo = false) {
    closeDeviceCommandsPopover();
    const icons = {
        refresh: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20 11.5a8 8 0 1 1-2.3-5.6"/><path d="M20 3.5V8h-4.5"/></svg>',
        eye: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7-11-7-11-7z"/><circle cx="12" cy="12" r="3"/></svg>',
        unlock: '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="5" y="10" width="14" height="10" rx="2"/><path d="M8 10V7a4 4 0 0 1 7.5-2"/></svg>',
        pin: '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="4" y="4" width="16" height="16" rx="3"/><circle cx="8" cy="9" r="1"/><circle cx="12" cy="9" r="1"/><circle cx="16" cy="9" r="1"/><circle cx="8" cy="14" r="1"/><circle cx="12" cy="14" r="1"/><circle cx="16" cy="14" r="1"/></svg>',
        reboot: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20 11a8 8 0 1 0-2.3 5.7"/><path d="M20 4v7h-7"/></svg>',
        replug: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 2v5M15 2v5"/><path d="M7 7h10v2.5a5 5 0 0 1-10 0V7Z"/><path d="M12 14.5V18a3 3 0 0 0 3 3h2"/></svg>',
        shutdown: powerIconSvg,
        apps: '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/></svg>',
        install: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3v12"/><path d="m7 10 5 5 5-5"/><path d="M5 20h14"/></svg>',
        shell: '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="2" y="3" width="20" height="18" rx="2"/><path d="m7 9 3 3-3 3M13 15h4"/></svg>',
        screenOff: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8Z"/></svg>',
        screenOn: '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M2 12h2M20 12h2M5 5l1.5 1.5M17.5 17.5 19 19M19 5l-1.5 1.5M6.5 17.5 5 19"/></svg>',
        brightness: '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="8.5"/><path d="M12 3.5a8.5 8.5 0 0 0 0 17Z" fill="currentColor" stroke="none"/></svg>',
    };
    const popover = document.createElement('div');
    popover.className = 'device-command-popover';
    popover.innerHTML = `
        <div class="device-command-popover__header">
            <strong>${t('devices.device_commands')}</strong>
            <span>${esc(displayName)}</span>
        </div>
        <div id="dc-error" class="modal__error" style="display:none"></div>
        <div class="device-command-list">
            <button type="button" class="device-command-btn" id="dc-refresh">
                ${icons.refresh}<span>${t('devices.force_refresh_status')}</span>
            </button>
            <button type="button" class="device-command-btn" id="dc-unlock">
                ${icons.unlock}<span>${t('devices.wake_unlock_screen')}</span>
            </button>
            <div class="device-pin-row">
                <input id="dc-pin" type="password" inputmode="numeric" pattern="[0-9]*"
                    minlength="4" maxlength="16" autocomplete="off" autocapitalize="none" spellcheck="false"
                    data-lpignore="true" data-1p-ignore="true" data-bwignore="true" placeholder="${t('devices.pin_placeholder')}">
                <button type="button" class="device-command-btn device-command-btn--icon" id="dc-enter-pin"
                    title="${t('devices.enter_pin')}" aria-label="${t('devices.enter_pin')}">${icons.pin}</button>
            </div>
            <button type="button" class="device-command-btn" id="dc-apps">
                ${icons.apps}<span>${t('devices.installed_apps')}</span>
            </button>
            ${can('device.install') ? `
            <button type="button" class="device-command-btn" id="dc-install">
                ${icons.install}<span>${t('devices.install_apk')}</span>
            </button>
            <input type="file" id="dc-install-file" accept=".apk,application/vnd.android.package-archive" style="display:none">
            ` : ''}
            <button type="button" class="device-command-btn" id="dc-shell">
                ${icons.shell}<span>${t('devices.adb_shell')}</span>
            </button>
            ${noVideo ? '' : `
            <button type="button" class="device-command-btn" id="dc-screen-off">
                ${icons.screenOff}<span>${t('devices.screen_off_keep_stream')}</span>
            </button>
            <button type="button" class="device-command-btn" id="dc-screen-on">
                ${icons.screenOn}<span>${t('devices.screen_on')}</span>
            </button>
            `}
            <div class="device-brightness-row">
                <span class="device-brightness-row__icon">${icons.brightness}</span>
                <input id="dc-brightness" type="range" min="0" max="100" step="1" value="50"
                    aria-label="${t('devices.screen_brightness')}">
                <span id="dc-brightness-val" class="device-brightness-row__val">50%</span>
                <button type="button" class="device-command-btn device-command-btn--icon" id="dc-brightness-apply"
                    title="${t('devices.apply_brightness')}" aria-label="${t('devices.apply_brightness')}">${icons.brightness}</button>
            </div>
            ${can('device.session-reset') ? `
            <button type="button" class="device-command-btn" id="dc-session-reset">
                ${icons.replug}<span>${t('devices.reset_session_replug')}</span>
            </button>
            ` : ''}
            ${can('device.reboot') ? `
            <button type="button" class="device-command-btn" data-command="reboot">
                ${icons.reboot}<span>${t('devices.restart_phone')}</span>
            </button>
            <button type="button" class="device-command-btn device-command-btn--danger" data-command="shutdown">
                ${icons.shutdown}<span>${t('devices.power_off_phone')}</span>
            </button>
            ` : ''}
        </div>
    `;
    document.body.appendChild(popover);
    deviceCommandsPopover = popover;
    deviceCommandsPopoverEvents = new AbortController();
    const eventOptions = { signal: deviceCommandsPopoverEvents.signal };
    const anchorRect = anchor.getBoundingClientRect();
    const popoverRect = popover.getBoundingClientRect();
    const margin = 8;
    const left = Math.min(window.innerWidth - popoverRect.width - margin, Math.max(margin, anchorRect.right - popoverRect.width));
    const belowTop = anchorRect.bottom + margin;
    const top = belowTop + popoverRect.height <= window.innerHeight - margin
        ? belowTop
        : Math.max(margin, anchorRect.top - popoverRect.height - margin);
    popover.style.left = `${left}px`;
    popover.style.top = `${top}px`;
    const errorEl = popover.querySelector('#dc-error');
    const sendCommand = async (button, command, pin, text) => {
        errorEl.style.display = 'none';
        button.disabled = true;
        try {
            const res = await fetch(`/api/devices/${encodeURIComponent(udid)}/command`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ command, pin, text }),
            });
            const data = await res.json();
            if (!res.ok) {
                showModalErr(errorEl, data.error ?? t('devices.command_failed'));
                return false;
            }
            return true;
        }
        catch {
            showModalErr(errorEl, t('devices.network_error'));
            return false;
        }
        finally {
            button.disabled = false;
        }
    };
    // Force refresh — asks the farm to immediately re-poll this device's status.
    // The farm re-polls its whole device set, so a fresh list arrives over the WS
    // and re-renders the cards. The popover stays open (close it via outside-click
    // or Escape) so several commands can be issued in a row.
    const refreshButton = popover.querySelector('#dc-refresh');
    refreshButton.addEventListener('click', () => {
        refreshButton.disabled = true;
        void fetch(`/api/devices/${encodeURIComponent(udid)}/refresh`, { method: 'POST' })
            .catch(() => { })
            .finally(() => { refreshButton.disabled = false; });
    });
    const unlockButton = popover.querySelector('#dc-unlock');
    unlockButton.addEventListener('click', () => { void sendCommand(unlockButton, 'unlock'); });
    const appsButton = popover.querySelector('#dc-apps');
    appsButton.addEventListener('click', () => {
        closeDeviceCommandsPopover();
        void showAppsModal(udid, displayName);
    });
    const shellButton = popover.querySelector('#dc-shell');
    shellButton.addEventListener('click', () => {
        closeDeviceCommandsPopover();
        showShellModal(udid, displayName);
    });
    // Install APK — pick a local .apk and push it to the device via the farm. The
    // file is sent as the raw request body (same binary-upload idiom as the clicker
    // code tab), and the install can take a while, so the button stays disabled and
    // shows progress until the farm reports a result. Popover stays open throughout.
    const installButton = popover.querySelector('#dc-install');
    const installFile = popover.querySelector('#dc-install-file');
    if (installButton && installFile) {
        const setInstallLabel = (text) => {
            installButton.innerHTML = `${icons.install}<span>${esc(text)}</span>`;
        };
        installButton.addEventListener('click', () => { if (!installButton.disabled)
            installFile.click(); });
        installFile.addEventListener('change', async () => {
            const file = installFile.files?.[0];
            installFile.value = ''; // allow re-selecting the same file later
            if (!file)
                return;
            errorEl.style.display = 'none';
            installButton.disabled = true;
            setInstallLabel(t('devices.installing', { file: file.name }));
            try {
                const res = await fetch(`/api/devices/${encodeURIComponent(udid)}/install`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/vnd.android.package-archive' },
                    body: file,
                });
                const data = await res.json().catch(() => ({}));
                if (!res.ok || !data.ok) {
                    showModalErr(errorEl, data.error ?? t('devices.install_failed'));
                    setInstallLabel(t('devices.install_apk'));
                }
                else {
                    setInstallLabel(t('devices.installed_ok'));
                    setTimeout(() => setInstallLabel(t('devices.install_apk')), 4000);
                }
            }
            catch {
                showModalErr(errorEl, t('devices.network_error'));
                setInstallLabel(t('devices.install_apk'));
            }
            finally {
                installButton.disabled = false;
            }
        });
    }
    // Screen on/off — scrcpy SET_SCREEN_POWER_MODE rides the live stream's control
    // channel (not ADB), so it only works while this device's inline stream is open.
    // Two explicit commands (not a toggle): the device's real screen state can be
    // changed out-of-band (physical button, another tab), so we never assume it.
    const setScreenPower = (on) => {
        errorEl.style.display = 'none';
        const session = inlineStreams.get(udid)?.session;
        if (!session || !session.sendScreenPower(on)) {
            showModalErr(errorEl, t('devices.open_stream_first'));
            return;
        }
        // Popover stays open (close via outside-click / Escape).
    };
    popover.querySelector('#dc-screen-off')?.addEventListener('click', () => setScreenPower(false));
    popover.querySelector('#dc-screen-on')?.addEventListener('click', () => setScreenPower(true));
    // Brightness — manual 0..255 via ADB (settings put system screen_brightness).
    // The slider is a 0..100% UI; convert to the Android 0..255 scale on apply.
    const brightnessSlider = popover.querySelector('#dc-brightness');
    const brightnessVal = popover.querySelector('#dc-brightness-val');
    const brightnessApply = popover.querySelector('#dc-brightness-apply');
    // Seed the slider from the device's last-polled brightness (synced by the farm
    // on each telemetry tick); fall back to the 50% default if not yet reported.
    const currentBrightness = appState.allDevices.get(udid)?.['screen.brightness'];
    if (typeof currentBrightness === 'number') {
        brightnessSlider.value = String(currentBrightness);
        brightnessVal.textContent = `${currentBrightness}%`;
    }
    brightnessSlider.addEventListener('input', () => {
        brightnessVal.textContent = `${brightnessSlider.value}%`;
    });
    brightnessApply.addEventListener('click', () => {
        const pct = parseInt(brightnessSlider.value, 10);
        const raw = Math.round((pct / 100) * 255);
        void sendCommand(brightnessApply, 'set-brightness', undefined, String(raw));
    });
    const pinInput = popover.querySelector('#dc-pin');
    const pinButton = popover.querySelector('#dc-enter-pin');
    // Prefill with the last PIN successfully sent to this device (kept per-udid in
    // localStorage) so repeated unlocks don't require retyping the same code.
    const pinStorageKey = `dc-pin:${udid}`;
    try {
        const savedPin = localStorage.getItem(pinStorageKey);
        if (savedPin)
            pinInput.value = savedPin;
    }
    catch { /* localStorage unavailable — ignore */ }
    pinButton.addEventListener('click', async () => {
        const pin = pinInput.value.trim();
        if (!/^\d{4,16}$/.test(pin)) {
            showModalErr(errorEl, t('devices.pin_must_be_digits'));
            pinInput.focus();
            return;
        }
        pinInput.value = '';
        if (await sendCommand(pinButton, 'enter-pin', pin)) {
            try {
                localStorage.setItem(pinStorageKey, pin);
            }
            catch { /* ignore */ }
            // Popover stays open (close via outside-click / Escape).
        }
    });
    pinInput.addEventListener('keydown', (event) => {
        if (event.key === 'Enter')
            pinButton.click();
    });
    // Reset session ("re-plug"): bounce the device off the farm and back so the modem
    // recovers after an MP-trigger, without a physical power-cycle. The card drops for a
    // couple of seconds and returns. Allowed while the clicker runs (server exempts it
    // from the read-only lock), so no clicker check here.
    const sessionResetButton = popover.querySelector('#dc-session-reset');
    sessionResetButton?.addEventListener('click', () => {
        if (!window.confirm(t('devices.confirm_session_reset', { name: displayName })))
            return;
        void sendCommand(sessionResetButton, 'session-reset');
    });
    popover.querySelectorAll('.device-command-btn').forEach((button) => {
        if (!button.dataset['command'])
            return;
        button.addEventListener('click', async () => {
            const command = button.dataset['command'];
            const question = command === 'shutdown'
                ? t('devices.confirm_power_off_phone', { name: displayName })
                : t('devices.confirm_restart_phone', { name: displayName });
            if (!window.confirm(question))
                return;
            void sendCommand(button, command);
        });
    });
    const closeOnOutsideClick = (event) => {
        if (popover.contains(event.target) || anchor.contains(event.target))
            return;
        closeDeviceCommandsPopover();
    };
    const closeOnEscape = (event) => {
        if (event.key !== 'Escape')
            return;
        closeDeviceCommandsPopover();
    };
    requestAnimationFrame(() => document.addEventListener('click', closeOnOutsideClick, { capture: true, ...eventOptions }));
    document.addEventListener('keydown', closeOnEscape, eventOptions);
}
